import panels from "./installation.panels";
import meter from "./installation.meter";
import general from "./installation.general";

export default {
  ["PANELS-REGULAR"]: panels,
  ["METER-REGULAR"]: meter,
  ["METER_MAAS-REGULAR"]: meter,
  ["TENANT"]: () => [],
  general
};
